const recaptchaService = {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,

  async loadRecaptcha() {
  return new Promise((resolve) => {
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(() => resolve());
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
	script.defer =true;  
    script.onload = () => {
      window.grecaptcha.ready(() => resolve());
    };
    document.head.appendChild(script);
  });
},


  async executeRecaptcha(action) {
    try {
      await this.loadRecaptcha();
      
      if (!window.grecaptcha || !window.grecaptcha.execute) {
        return null;
      }

      const token = await window.grecaptcha.execute(this.siteKey, { action });
      return token;
    } catch (error) {
      return null;
    }
  }
};

export default recaptchaService; 